/* @flow */
import React from 'react';
// $FlowIgnore
import { MdInfoOutline } from 'react-icons/md';

export default function ArrowDownIcon({
  style
}: Object): React.Element {
  return <MdInfoOutline style={style} />;
}
